import React from "react";
import { earlyActiveNow } from "../../lib/calc";

export const proposalTotalsInput = (quote, selections, promo) => ({
  items: quote.items,
  selections,
  tax_regime: quote.tax_regime,
  previdenza: quote.previdenza,
  cassa_rate: quote.cassa_rate || 4,
  ritenuta_acconto: quote.ritenuta_acconto,
  addebito_bollo: quote.addebito_bollo,
  client_type: quote.client?.type || "business",
  payment_terms: quote.payment_terms,
  global_discount_type: quote.global_discount_type || "none",
  global_discount_value: quote.global_discount_value || 0,
  early_discount_type: quote.early_discount_type || "none",
  early_discount_value: quote.early_discount_value || 0,
  early_active: earlyActiveNow(quote.early_discount_type, quote.early_discount_deadline),
  promo_discount_type: promo?.discount_type || "none",
  promo_discount_value: promo?.discount_value || 0,
  groups: quote.groups || [],
});

export function SumRow({ label, value, testid, muted }) {
  return (
    <div className="flex items-center justify-between">
      <span className={muted ? "text-slate-500" : "text-slate-700"}>{label}</span>
      <span data-testid={testid} className="font-mono font-semibold text-slate-900">{value}</span>
    </div>
  );
}
